import {axiosUtil} from "../../../../utils/axios_util";

const XPoolAllocationApi = {
    //分页查询A池
    manageXPoolPage(data:powerSearchData) {
        return axiosUtil({
            url: '/middleNumberPool/manager/page',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
}

export default XPoolAllocationApi
